export const emptyToUndefined = (
  value: string | undefined | null
): string | undefined => {
  if (value === undefined || value === null || value === '') return undefined

  return value
}
